// src/modules/competition/components/CompetitorCards/index.js
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import MinisterCard from '../MinisterCard';
import CakeGiverCard from '../CakeGiverCard';

const CompetitorCards = ({ ministerOfActivity, lowestCompetitor, isTeamBased, lowestTeam }) => {
    return (
        <Row className="mb-3">
            <Col md={6}>
                <MinisterCard competitor={ministerOfActivity} />
            </Col>
            <Col md={6}>
                {isTeamBased
                    ? <CakeGiverCard team={lowestTeam} />
                    : <CakeGiverCard competitor={lowestCompetitor} />
                }
            </Col>
        </Row>
    );
};

CompetitorCards.propTypes = {
    ministerOfActivity: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        profilePicture: PropTypes.string,
        totalPoints: PropTypes.number.isRequired
    }),
    lowestCompetitor: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        profilePicture: PropTypes.string,
        totalPoints: PropTypes.number.isRequired
    }),
    isTeamBased: PropTypes.bool,
    lowestTeam: PropTypes.shape({
        name: PropTypes.string.isRequired,
        icon: PropTypes.string,
        totalPoints: PropTypes.number,
    }),
};

export default CompetitorCards;
